//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  name: "DoughnutChartInfo",
  props: {
    element: {
      type: Object,
      default: () => ({}),
    },
    isEmpty: {
      type: Boolean,
      required: true,
    },
  },
  data() {
    return {
      isOverflowing: false,
    };
  },
  mounted() {
    const el = this.$el.querySelector(".truncate");
    this.isOverflowing = el.offsetWidth < el.scrollWidth;
  },
  methods: {
    formatElement(element) {
      const name = this.$te(element.name) ? this.$t(element.name) : element.name;
      const value = this.formatValue(element.value);
      const measure = element.measure ? element.measure : "";
      return `<span class="font-bold">${name}</span> ${value} ${measure}`;
    },
    formatValue(value) {
      // Hack because we don't want the default (correct) thousands separator for spanish locale
      return this.$n(value, {}, this.$i18n.locale === "es" ? "de" : this.$i18n.locale);
    },
  },
};
